import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { observer } from 'mobx-react-lite';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Applications from './components/Applications';
import Statistics from './components/Statistics';
import Settings from './components/Settings';
import EmailTemplates from './components/EmailTemplates';
import TildaForms from './components/TildaForms';
import Deployments from './components/Deployments';
import DeploymentTemplates from './components/DeploymentTemplates';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { useStore } from './store';
import { useEffect } from 'react';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
    },
});

const App: React.FC = observer(() => {
    const { authStore } = useStore();

    useEffect(() => {
        // Проверяем токен при загрузке приложения
        const token = localStorage.getItem('token');
        if (token) {
            authStore.setToken(token);
            authStore.checkAuth();
        }
    }, [authStore]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="/dashboard" replace />} />
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="applications" element={<Applications />} />
                        <Route path="statistics" element={<Statistics />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="email-templates" element={<EmailTemplates />} />
                        <Route path="tilda-forms" element={<TildaForms />} />
                        <Route path="deployments" element={<Deployments />} />
                        <Route path="deployment-templates" element={<DeploymentTemplates />} />
                    </Route>
                </Routes>
            </Router>
        </ThemeProvider>
    );
});

export default App;